module.exports = __webpack_public_path__ + "static/media/robot-green-full.7d9747fb.svg";